// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__84bJi","productName":"Table_productName__3zK3h"};